/* unplugin-vue-components disabled */import script from "./instructions.vue?vue&type=script&setup=true&name=Instructions&lang=js"
export * from "./instructions.vue?vue&type=script&setup=true&name=Instructions&lang=js"

import "./instructions.vue?vue&type=style&index=0&id=5322be84&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5322be84"]])

export default __exports__